const navItems = [
  {
    id: 1,
    name: "home",
    url: "/",
  },
  {
    id: 5,
    name: "projects",
    url: "/portfolio",
  },
  {
    id: 3,
    name: "our services",
    url: "/portfolio",
  },
  {
    id: 4,
    name: "contact",
    url: "/contact",
  },
  {
    id: 2,
    name: "about us",
    url: "/about",
  },
];
export default navItems;
